@file:OptIn(InternalResourceApi::class)

package mynotes.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/mynotes.composeapp.generated.resources/"

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_708_724_193)
internal val Res.drawable.ic_my_notes_logo: DrawableResource by lazy {
      DrawableResource("drawable:ic_my_notes_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_my_notes_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(885_759_804)
internal val Res.drawable.notes: DrawableResource by lazy {
      DrawableResource("drawable:notes", setOf(
        ResourceItem(setOf(), "${MD}drawable/notes.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("ic_my_notes_logo", Res.drawable.ic_my_notes_logo)
  map.put("notes", Res.drawable.notes)
}
